var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFullscreen = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M2.5 16a1.5 1.5 0 0 1 3 0v2.5H8a1.5 1.5 0 0 1 0 3H5A2.5 2.5 0 0 1 2.5 19zm0-8V5A2.5 2.5 0 0 1 5 2.5h3a1.5 1.5 0 1 1 0 3H5.5V8a1.5 1.5 0 1 1-3 0m19 11a2.5 2.5 0 0 1-2.5 2.5h-3a1.5 1.5 0 0 1 0-3h2.5V16a1.5 1.5 0 0 1 3 0zm0-11a1.5 1.5 0 0 1-3 0V5.5H16a1.5 1.5 0 0 1 0-3h3A2.5 2.5 0 0 1 21.5 5z"
})));
export default SvgFullscreen;